'use strict';

var tealium = require('../tealium'),
	util = require('../../../../../app_fbb_core/cartridge/js/util');

var product = {
    init: function () {
 	
    	//$('body').off('click', '.add-to-cart').on('click', '.add-to-cart', product.addToCart);
        // Add to Wishlist 
    	$(document.body).off('click', '[data-action="wishlist"]').on('click', '[data-action="wishlist"]', function () {
        	var obj = {
        		event_name : "add_to_wishlist"      		
        	}
        	if(utag_data.product_id && utag_data.product_id.length > 0) {
        		obj.product_id = utag_data.product_id[0];
        	}
        	tealium.triggerEvent(obj);
    	});  
    	
    	$(document.body).off('click','.share-icon-container a').on('click','.share-icon-container a', function(e){
        	var obj = {
        		event_name:"social-share",
        		social_network:$(this).data("share"),
        		social_target:window.location.href
        		};
        	tealium.triggerEvent(obj);    		
    	}); 
    	$(document.body).off('click', '.product-thumbnails img').on('click', '.product-thumbnails img', function(e) {
    		e.preventDefault();
        	var obj = {
        		event_name : "product_interaction",
        		product_id : $(this).data("productid"),
        		product_interaction_type : "select image",
                product_viewtype : "standard",
                mini_sps_id : [""],
                uber_sps_id : [""]       		
            }
            
            var pids = $("input[name='pid']", ".product-set-item");
            var mpids = $("input[name='mpid']", ".product-set-item");
            if (pids.length > 1 && $('#pdpMain').find('.main-product-set-details').data('containsvariationgroups') === true) {
                obj.product_id = [];
                obj.mini_sps_id = [];
                obj.uber_sps_id = [];
                obj.product_item_id = [];
                obj.product_viewtype = [];
                for (var i=0; i < pids.length; i++) {
                    if ($.isNumeric($(pids[i]).val())) {
                        obj.product_id.push($(pids[i]).val());
                    }
                    else {
                        obj.product_id.push($(mpids[i]).val());
                    }

                    obj.product_item_id.push($($(".product-set-item")[i]).data("mainframeid"));
                    obj.product_viewtype.push("standard");
                    obj.mini_sps_id.push($("input[name='pid']", ".pdpForm").val());
                    obj.uber_sps_id.push($("input[name='uberSetId']", ".pdpForm").val());
                }
            }
        	tealium.triggerEvent(obj);
    	});
    	$(document.body).off('click', '.product-info .tab-label').on('click', '.product-info .tab-label', function(e) {
        	var obj = {
        		event_name : "product_interaction",
        		product_interaction_type : "tab selection",
        		product_interaction_value : $(this)[0].innerHTML,
                product_viewtype : "standard",
                mini_sps_id : [""],
                uber_sps_id : [""]      		
        	}
        	if(utag_data.product_id && utag_data.product_id.length > 0) {
        		obj.product_id = utag_data.product_id[0];
            }
            var pids = $("input[name='pid']", ".product-set-item");
            var mpids = $("input[name='mpid']", ".product-set-item");
            if (pids.length > 1 && $('#pdpMain').find('.main-product-set-details').data('containsvariationgroups') === true) {
                obj.product_id = [];
                obj.mini_sps_id = [];
                obj.uber_sps_id = [];
                obj.product_item_id = [];
                obj.product_viewtype = [];
                for (var i=0; i < pids.length; i++) {
                    if ($.isNumeric($(pids[i]).val())) {
                        obj.product_id.push($(pids[i]).val());
                    }
                    else {
                        obj.product_id.push($(mpids[i]).val());
                    }

                    obj.product_item_id.push($($(".product-set-item")[i]).data("mainframeid"));
                    obj.product_viewtype.push("standard");
                    obj.mini_sps_id.push($("input[name='pid']", ".pdpForm").val());
                    obj.uber_sps_id.push($("input[name='uberSetId']", ".pdpForm").val());
                }
            }
        	tealium.triggerEvent(obj);
    	});     	    	     	   	
    },
    //see pages/product/addToCart.js
    addToCart: function () {	
    	
    }
}

module.exports = product;

